import React, {useContext, useEffect, useState} from "react";
import { useHistory } from "react-router-dom";
import Button from "../../shared/components/formElements/Button";
import Input from "../../shared/components/formElements/Input";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import { useForm } from "../../shared/hooks/form-hook";
import { useHttpClient } from "../../shared/hooks/http-hook";
import {
  VALIDATOR_MAX,
  VALIDATOR_MAXLENGTH,
  VALIDATOR_NOT_REQUIRE,
  VALIDATOR_NUMERIC,
  VALIDATOR_REQUIRE,
  VALIDATOR_SPECIAL_CHARACHTER,
} 
from "../../shared/util/validators";
import "./Consignments.css";
import { AuthContext } from '../../shared/context/auth-context';
import Capitalize from "../../shared/components/UIElements/Capitalize ";


const NewConsignment = () => {
  const auth = useContext(AuthContext);
  const [consignments, setConsignments] = useState([]);
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [formState, inputHandler] = useForm(
    {
      style: {
        value: "",
        isValid: false,
      },
      company: {
        value: "",
        isValid: false,
      },
      color: {
        value: "",
        isValid: false,
      },
      USSize: {
        value: "",
        isValid: false,
      },
      EURSize: {
        value: "",
        isValid: true,
      },
      quantity: {
        value: 0,
        isValid: true,
      },
      cost: {
        value: "",
        isValid: true,
      },
      price: {
        value: "",
        isValid: true,
      },
      website: {
        value: "",
        isValid: true,
      },
      description: {
        value: "",
        isValid: true,
      },
    },
    false
  );
  const history = useHistory();
  const consignmentSubmitHandler = async (event) => {
    event.preventDefault();
    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL+"/consignments/new",
        "POST",
        JSON.stringify({
          style:
            Capitalize(formState.inputs.style.value) +
            "_" +
            Capitalize(formState.inputs.color.value) +
            "_" +
            Capitalize(formState.inputs.USSize.value),
          company: (formState.inputs.company.value).toUpperCase().trim(),
          color: Capitalize(formState.inputs.color.value),
          USSize: Capitalize(formState.inputs.USSize.value),
          EURSize: Capitalize(formState.inputs.EURSize.value),
          quantity: formState.inputs.quantity.value,
          cost: formState.inputs.cost.value,
          price: formState.inputs.price.value,
          website: formState.inputs.website.value,
          description: Capitalize(formState.inputs.description.value),
        }),
        { "Content-Type": "application/json",
        Authorization: 'Bearer '+ auth.token }
      );
      history.push("/consignments");
    } catch (err) {}
  };

  useEffect(() => {
    const fetchConsignments = async () => {
      let responseData;
      try {
        responseData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL+ "/consignments", 
          "GET" , 
          null,
          {Authorization: 'Bearer '+ auth.token}
        );
        setConsignments(responseData.consignments);
      } catch (err) { }
    };
    fetchConsignments();
  }, [sendRequest, auth.token]);

  const ConsignmentSet = new Set();
  consignments && consignments.forEach(consignment => {
    ConsignmentSet.add(consignment.company);  
  }) 

  const companySuggestion = ConsignmentSet ? Array.from(ConsignmentSet).map(any => {
    return({name: any})
  }) : []
  
  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      <form className="consignment-form" onSubmit={consignmentSubmitHandler}>
        {isLoading && <LoadingSpinner asOverlay />}
        <h2 className="header-text-Newconsignment">Create new Consignment</h2>

        <div className="flex justify-center">
          <div className=" w-50 pa1 mr1">
            <code>
              <Input
                id="style"
                element="input" 
                type="text"
                label="Style"
                validators={[
                  VALIDATOR_REQUIRE(),
                  VALIDATOR_MAXLENGTH(23),
                  VALIDATOR_SPECIAL_CHARACHTER(),
                ]}
                errorText="Please enter a valid (Less than 20 characters) style."
                onInput={inputHandler}
                focus="autoFocus"
              />
            </code>
          </div>
          <div className=" w-50 pa1 mr1">
            <code>
              <Input
                id="company"
                element="smart_input"
                type="text"
                label="Company"
                validators={[
                  VALIDATOR_REQUIRE(),
                  VALIDATOR_MAXLENGTH(23),
                  VALIDATOR_SPECIAL_CHARACHTER(),
                ]}
                suggestionArray={companySuggestion} 
                errorText="Please enter a valid (Less than 20 characters) company."
                onInput={inputHandler}
              />
            </code>
          </div>
        </div>

        <div className="flex justify-center">
          <div className=" w-50 pa1 mr1">
            <code>
              <Input
                id="color"
                element="input"
                type="text"
                label="Color"
                validators={[
                  VALIDATOR_REQUIRE(),
                  VALIDATOR_MAXLENGTH(20),
                  VALIDATOR_SPECIAL_CHARACHTER(),
                ]}
                errorText="Please enter less than 20 characters."
                onInput={inputHandler}
              />
            </code>
          </div>
          <div className=" w-50 pa1 mr1">
            <code>
              <Input
                id="quantity"
                element="input"
                type="number"
                label="Quantity"
                validators={[
                  VALIDATOR_REQUIRE(),
                  VALIDATOR_NUMERIC(),
                  VALIDATOR_MAX(31),
                ]}
                errorText="Please enter a valid quantity."
                onInput={inputHandler}
              />
            </code>
          </div>
        </div>
        <div className="flex justify-center">
          <div className=" w-50 pa1 mr1">
            <code>
              <Input
                id="USSize"
                element="input"
                type="text"
                label="US Size"
                validators={[ 
                  VALIDATOR_REQUIRE(),
                  VALIDATOR_MAXLENGTH(20),
                  VALIDATOR_SPECIAL_CHARACHTER(),]}
                errorText="Please enter a valid EUR size."
                onInput={inputHandler}
              />
            </code>
          </div>
          <div className=" w-50 pa1 mr1">
            <code>
              <Input
                id="EURSize"
                element="input"
                type="text"
                label="EUR Size"
                validators={[
                  VALIDATOR_REQUIRE(),
                  VALIDATOR_MAXLENGTH(20),
                  VALIDATOR_SPECIAL_CHARACHTER(), 
                ]}
                errorText="Please enter a valid US size."
                onInput={inputHandler}
              />
            </code>
          </div>
        </div>
        <div className="flex justify-center">
          <div className=" w-50 pa1 mr1">
            <code>
              <Input
                id="cost"
                element="input"
                type="number"
                label="Cost"
                validators={[VALIDATOR_REQUIRE(), VALIDATOR_NUMERIC()]}
                errorText="Please enter a valid cost."
                onInput={inputHandler}
              />
            </code>
          </div>
          <div className=" w-50 pa1 mr1">
            <code>
              <Input
                id="price"
                element="input"
                type="number"
                label="Price"
                validators={[VALIDATOR_REQUIRE(), VALIDATOR_NUMERIC()]}
                errorText="Please enter a valid price."
                onInput={inputHandler}
              />
            </code>
          </div>
        </div>
        <div className="flex justify-center">
          <div className=" w-50 pa1 mr1">
            <code>
              <Input
                id="website"
                element="input"
                type="text"
                label="Website"
                validators={[VALIDATOR_NOT_REQUIRE()]}
                errorText="Please enter a valid Website."
                onInput={inputHandler}
              />
            </code>
          </div>
          <div className=" w-50 pa1 mr1">
            <code>
              <Input
                id="description"
                label="Description"
                validators={[
                  VALIDATOR_SPECIAL_CHARACHTER(),
                  VALIDATOR_MAXLENGTH(180),
                ]}
                onInput={inputHandler}
                errorText="Please enter a valid description (Max 180 Characters)."
              />
            </code>
          </div>
        </div>

        <Button type="submit" disabled={!formState.isValid}>
          ADD ITEM
        </Button>
        <Button inverse to="/consignments">
          CANCEL
        </Button>
      </form>
    </React.Fragment>
  );
};

export default NewConsignment;
